/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
"use strict";

import $ from 'jquery';
import ko from 'knockout';
import 'jquery-format';

import clientComponent from '../../client/lib/clientComponent';
import app from '../../client/lib/appContext';
import dummyComponent from '../../client/lib/dummyComponent';

var self = {};

//OBJECT PROPERTIES

// TODO: Need to pull product name from config (changed to match the product name returned from test server)
self.productName = ko.observable("appSpaceClient");

self.notifyVisible = ko.observable(false);
self.notifyHeight = ko.observable("0px");
self.notifyMsg = ko.observable("");
self.notifyClick = function () {
    clearTimeout(app.browser.notifier.timerDelay);
    clearTimeout(app.browser.notifier.timerHide);
    app.browser.notifier.timerDelay = 0;
    app.browser.notifier.timerHide = 0;
    self.notifyVisible(false);
    self.notifyHeight("0px");
};

//Register a "dummy" component for place-holding...
//This is used in several sub-components as well.
app.dummyComp = dummyComponent;

let iDevices = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
];

app.browser = {};
// browser detection
app.browser.isOpera = !!window.opera || !!window.opr || navigator.userAgent.indexOf(' OPR/') >= 0; // Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
app.browser.isFirefox = typeof InstallTrigger !== 'undefined'; // Firefox 1.0+
app.browser.isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.toLowerCase().indexOf('safari') > 0 || navigator.userAgent.toLowerCase().indexOf('applewebkit') > 0 || navigator.standalone != null;
app.browser.isIE = /*@cc_on!@*/ false || document.documentMode; // At least IE6
app.browser.isChrome = !app.browser.isIE && !!window.chrome && !app.browser.isOpera; // Chrome 1+
app.browser.isBlink = (app.browser.isChrome || app.browser.isOpera) && window.CSS;
app.browser.isEdge = window.navigator.userAgent.indexOf("Edge") > -1;
app.browser.isIOS = iDevices.indexOf(navigator && navigator.platform) !== -1;

app.browser.notifier = {};
app.browser.notifier.timerDelay = 0;
app.browser.notifier.timerHide = 0;

/**
 * Logic to rescale the zebra canvases when the browser resolution changes
 */
app.browser.watchScreenResolution = function () {
    let currentRatio = window.devicePixelRatio,
        mediaQuery = window.matchMedia(`screen and (min-resolution: ${currentRatio+0.01}dppx), screen and (max-resolution: ${currentRatio-0.01}dppx)`),
        handleResolutionChange = () => {
            // remove the old media query listeners
            mediaQuery.removeListener(handleResolutionChange);
            currentRatio = window.devicePixelRatio;

            if (zebra && zebra.ui) {
                // Have the zebra canvases rescale based on the new ratio
                zebra.ui.$deviceRatio = currentRatio;
                zebra.ui.$canvases.forEach((zCanvas) => {
                    zCanvas.$context = zCanvas.initContext(zCanvas.width, zCanvas.height);
                    zCanvas.vrp();
                });
            }

            // add another media query accounting for the new resolution
            mediaQuery = window.matchMedia(`screen and (min-resolution: ${currentRatio+0.01}dppx), screen and (max-resolution: ${currentRatio-0.01}dppx)`);
            mediaQuery.addListener(handleResolutionChange);
        };
    mediaQuery.addListener(handleResolutionChange);
};

/**
 * Shows a specified message for a specified amount of time on top of the workspace.
 * @param {String} [msg = "No message"] - The message to display in the toast. HTML is supported.
 * @param {Number} [duration = 5000] - The amount of time in milliseconds that the toast should be displayed for.
 * @param {Number} [delay = 0] - The amount of time to wait before displaying the toast.
 * @param {Boolean} [logConsole = true] - Flag to determine if the message should also be logged to the console.
 */
app.browser.notifier.showToast = function (msg = 'No message', duration = 5000, delay = 0, logConsole = true) {
    // turn off the hardcoded CSS hidden style set initially to prevent flashing...AM
    document.getElementById("notifier").style.visibility = 'visible';

    if (app.browser.notifier.timerDelay !== 0) {
        clearTimeout(app.browser.notifier.timerDelay);
        clearTimeout(app.browser.notifier.timerHide);
    }
    app.browser.notifier.timerDelay = setTimeout(function (vm, $, app, msg, duration) {
        if (app.browser.notifier.timerDelay === 0) {
            // if our timer was cleared, we need to get out.
            return;
        }

        vm.notifyHeight("auto");
        vm.notifyVisible(true);
        vm.notifyMsg(msg);
        app.browser.notifier.timerHide = setTimeout(function ($, vm) {
            $('#notifier').addClass("ui-draggable-dragging").animate({
                height: 0,
                opacity: 1
            }, 1000, function () {
                //animation complete, remove the "ui-draggable-dragging" CSS class.
                $('#notifier').removeClass("ui-draggable-dragging");
                vm.notifyVisible(false);
                vm.notifyHeight("0px");
                // clear our timers
                clearTimeout(app.browser.notifier.timerDelay);
                clearTimeout(app.browser.notifier.timerHide);
                app.browser.notifier.timerDelay = 0;
                app.browser.notifier.timerHide = 0;
            });
        }, duration, $, vm);

    }, delay, self, $, app, msg, duration);

    // Also log any toasts to the console
    if (logConsole) {
        console.log("Toast:", msg.replace(/<br\/?>/g, '\n'));
    }
};

if (!app.browser.isChrome && !app.browser.isSafari) {
    app.browser.notifier.showToast("You are using a non-recommended browser; some features may not work properly.<br>Please contact support for details.", 3000);
}

// Register the product browser component. NOTE: This is shared between mobile and
// desktop versions of the client, which is why its a component.
// requirejs.config({
//     'packages': [{
//         'name': 'appSpaceClient',
//         'location': 'client',
//         'main': 'lib/clientComponent'
//     }]
// });

ko.components.register("appSpaceClient", clientComponent);

//Load and Display the product browser component.
self.productCompName = ko.observable("appSpaceClient");

export default self;
